import css from 'styled-jsx/css';
import { serif, sansSerif } from 'styles/css-constants';

export default css`
  :global(.AmpPostLayout .Teaser--recipeRoundup) {
    font-family: ${serif};
    margin-bottom: 1.5rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #c2bab9;
  }

  :global(.AmpPostLayout .Teaser--recipeRoundup) a {
    text-decoration: none;
    color: black;
    text-align: center;
  }

  :global(.AmpPostLayout .Post__recipeCollection) h2 {
    border-bottom: 2px solid #fcd110;
    font-size: 25px;
  }

  :global(.AmpPostLayout .Post__recipeCollection) p {
    margin-bottom: 1em;
    font-family: ${serif};
    line-height: 1.5;
    font-size: 18px;
  }

  :global(.AmpPostLayout .Post__recipeCollection p a) {
    text-decoration: none;
    border-bottom: 1px solid #ff4d56;
    color: #000;
  }
`;
